<template>
    <div class="mt-2 mb-4">
        <b-row style="">
            <div class="col-md-12 mt-3 mb-3">
                <b-row class="my-1">
                    <b-col sm="12" class="align-items-center d-flex justify-content-left">
                        <h4 class="" style="color:black;"
                            v-html="this.modelData['outcome_type_model']['outcome_type'] + '</br> ' + this.modelData['model']['outcome_code'] + ': ' + this.modelData['model']['outcome_name']">
                        </h4>
                    </b-col>
                </b-row>
            </div>
        </b-row>

        <b-row style="background-color:#6C6C6C; margin: auto;" >
            <div class="col-md-12 mt-3 mb-3">
                <b-row class="my-1">
                    <b-col sm="6" class="align-items-center d-flex justify-content-left">
                        <p style="color:#FFFFFF; font-family:roboto; font-size:22px;" class="mt-2">Member States Voluntary Reporting</p>
                    </b-col>
                    <b-col sm="6" class="mt-1">
                        <b-row>
                            <b-col sm="6" class="text-right">
                                <label class="mt-2" style="font-family:roboto; color:#FFFFFF; font-size:17px;">Select reporting period</label>
                            </b-col>
                            <b-col sm="6" class="text-left">
                                <b-form-select v-model="model.period_id" size="sm" required
                                    style="border-radius: unset;" @change="loadReport" class="col-xl-12 mt-1">
                                    <option value="">-- none --</option>
                                    <option v-for="period in modelData['reporting_period']" v-bind:key="period"
                                        :value="period.id">
                                        {{ period.period }}
                                    </option>
                                </b-form-select>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col sm="6" class="text-right">
                                <label class="mt-2" style="font-family:roboto; color:#FFFFFF; font-size:17px;">Select Your Country</label>
                            </b-col>
                            <b-col sm="6" class="text-left">
                                <b-form-select v-model="model.country_id" size="sm" required style="border-radius: unset;"
                                        class="col-xl-12 mt-1">
                                <option value="">-- none --</option>
                                <option v-for="item in modelData['reporting_country']" v-bind:key="item" :value="item.id"> {{ item.country_name}}</option>
                                </b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </div>
        </b-row>
        <div v-bind:hidden="hideTabs" class="mt-4">
            <b-tabs pills card vertical>
                <form ref="form" @submit.prevent="saveEditReports()">
                    <div class="row mt-4">
                        <b-tab class="mb-4" active style="background-color:none;">
                            <template v-slot:title>
                                <h6 class="mb-2 mt-3"
                                    style="font-weight: 600; font-size:17px; font-family:roboto; color:#1D1D1D;">OUTCOME
                                    TYPE</h6>
                            </template>
                            <b-container>
                                <b-card-text>
                                    <b-col>
                                        <b-row>
                                            <b-col>
                                                <h5 class="mheader"
                                                    style="font-weight: 600; font-family:Roboto; color:#202020;">Outcome
                                                    Type</h5>
                                                <span style="font-family:roboto; font-size:18px;"
                                                    v-html="this.modelData['outcome_type_model']['outcome_type']" />
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                                <b-card-text>
                                    <b-col>
                                        <b-row>
                                            <b-col>
                                                <h5 class="mheader"
                                                    style="font-weight: 600; font-family:Roboto; color:#202020;">Summary
                                                </h5>
                                                <span style="font-family:roboto; font-size:18px;"
                                                    v-html="modelData['model']['outcome_summary']" />
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                                <b-card-text>
                                    <b-col>
                                        <h5 class="mheader"
                                            style="font-weight: 600; font-family:Roboto; color:#202020;">Member State Actions Required</h5>
                                        <span style="font-family:roboto; font-size:18px;"
                                            v-html="modelData['model']['actions_required']" />
                                    </b-col>
                                </b-card-text>
                            </b-container>
                        </b-tab>
                        <b-tab class="mb-4">
                            <template v-slot:title>
                                <h6 class="mb-2 mt-3"
                                    style="font-weight: 600; font-size:17px; font-family:roboto; color:#1D1D1D;">RESULTS
                                </h6>
                            </template>
                            <b-card-text>
                                <b-col>
                                    <b-row>
                                        <b-col>
                                            <b-container>
                                                <h5 style="font-weight: 600; font-family:Roboto; color:#1D1D1D;">Results
                                                </h5>
                                            </b-container>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-card-text>
                            <b-card-text>
                                <b-col>
                                    <b-row>
                                        <b-col>
                                            <b-container class="">
                                                <b-tabs justified pills card nav-wrapper-class="w-40"
                                                    style="background-color: white;">
                                                    <b-tab active>
                                                        <template v-slot:title>
                                                            <h6 class="mb-0"
                                                                style="font-weight: normal; color:#1D1D1D;">Outcome</h6>
                                                        </template>
                                                        <div class="row">
                                                            <b-col sm="12" class="h-25" style="">
                                                                <div v-bind:style="outcomeShow" v-html="model.output">
                                                                </div>
                                                                <Vue-editor v-bind:style="outcomeEdit" id="output"
                                                                    name="output" class="" placeholder=""
                                                                    :maxlength="max" rows="2" max-rows="8"
                                                                    v-bind:disabled="savingInfo"
                                                                    v-model="model.output"></Vue-editor>
                                                            </b-col>
                                                        </div>
                                                        <div class="row">
                                                            <b-col sm="10">
                                                            </b-col>
                                                            <b-col sm="2" class="mt-2"
                                                                style="text-align:center; background-color:#96C65A;">
                                                                <div style="float: left;">
                                                                    <b-button @click="editOutcome = false"
                                                                        v-bind:style="outcomeEdit" type="submit"
                                                                        v-bind:disabled="savingInfo" class="" size="md"
                                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                                        <span v-if="savingInfo"><i
                                                                                class="fa fa-spinner fa-spin"></i>
                                                                            Loading
                                                                            ...</span>
                                                                        <span v-else>{{ saveText }}</span>
                                                                    </b-button>
                                                                    <b-button size="md" @click="editOutcome = true"
                                                                        v-bind:style="outcomeShow"
                                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                                        <span>Update</span>
                                                                    </b-button>
                                                                </div>
                                                            </b-col>
                                                        </div>
                                                        <b-row>
                                                            <b-col sm="9" class="mt-3">
                                                            </b-col>
                                                            <b-col sm="3" class="mt-3">
                                                                <div style="clear: both; float: right;"><span
                                                                        v-html="processingMessage" />
                                                                </div>
                                                            </b-col>
                                                        </b-row>
                                                    </b-tab>
                                                    <b-tab>
                                                        <template v-slot:title>
                                                            <h6 class="mb-0"
                                                                style="font-weight: normal; color:#1D1D1D;">Impact</h6>
                                                        </template>
                                                        <div class="row">
                                                            <b-col sm="12" class="h-25" style="">
                                                                <div v-bind:style="impactShow" v-html="model.impact">
                                                                </div>
                                                                <vue-editor v-bind:style="impactEdit" id="output"
                                                                    name="output" class="" placeholder=""
                                                                    :maxlength="max" rows="2" max-rows="8"
                                                                    v-bind:disabled="savingInfo"
                                                                    v-model="model.impact" />
                                                            </b-col>
                                                        </div>
                                                        <div class="row">
                                                            <b-col sm="10">
                                                            </b-col>
                                                            <b-col sm="2" class="mt-2"
                                                                style="text-align:center; background-color:#96C65A;">
                                                                <div style="float: left;">
                                                                    <b-button @click="editImpact = false"
                                                                        v-bind:style="impactEdit" type="submit"
                                                                        v-bind:disabled="savingInfo" class="" size="md"
                                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                                        <span v-if="savingInfo"><i
                                                                                class="fa fa-spinner fa-spin"></i>
                                                                            Loading
                                                                            ...</span>
                                                                        <span v-else>{{ saveText }}</span>
                                                                    </b-button>
                                                                    <b-button size="md" @click="editImpact = true"
                                                                        v-bind:style="impactShow"
                                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                                        <span>Update</span>
                                                                    </b-button>
                                                                </div>
                                                                <br>
                                                                <div style="clear: both; float: right;"><span
                                                                        v-html="processingMessage" />
                                                                </div>
                                                            </b-col>
                                                        </div>
                                                        <b-row>
                                                            <b-col sm="9" class="mt-3">
                                                            </b-col>
                                                            <b-col sm="3" class="mt-3">
                                                                <div style="clear: both; float: right;"><span
                                                                        v-html="processingMessage" />
                                                                </div>
                                                            </b-col>
                                                        </b-row>
                                                    </b-tab>
                                                </b-tabs>
                                            </b-container>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-card-text>
                        </b-tab>
                        <b-tab class="mb-4">
                            <template v-slot:title>
                                <h6 class="mb-2 mt-3"
                                    style="font-weight: 600; font-size:17px; font-family:roboto; color:#1D1D1D;">RESOURCES</h6>
                            </template>
                            <b-container>
                                <b-card-text>
                                    <b-col>
                                        <b-row>
                                            <b-col>
                                                <h5 style="font-weight:600; font-family:Roboto; color:#202020;">
                                                    Resources</h5>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                                <b-card-text>
                                    <b-col>
                                        <b-row>
                                            <b-col class="h-25">
                                                <div v-bind:style="resourcesShow" v-html="model.resources"></div>
                                                <vue-editor v-bind:style="resourcesEdit" id="resources" name="resources"
                                                    placeholder="" :maxlength="max" rows="2" max-rows="8"
                                                    v-bind:disabled="savingInfo" v-model="model.resources" />
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                            </b-container>
                            <b-card-text>
                                <b-col>
                                    <b-container>
                                        <b-row>
                                            <b-col sm="10">
                                            </b-col>
                                            <b-col sm="2" class="mt-2"
                                                style="text-align:center; background-color:#96C65A;">
                                                <div style="float: left;">
                                                    <b-button @click="editResources = false"
                                                        v-bind:style="resourcesEdit" type="submit"
                                                        v-bind:disabled="savingInfo" class="" size="md"
                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                        <span v-if="savingInfo"><i class="fa fa-spinner fa-spin"></i>
                                                            Loading ...</span>
                                                        <span v-else>{{ saveText }}</span>
                                                    </b-button>
                                                    <b-button size="md" @click="editResources = true"
                                                        v-bind:style="resourcesShow"
                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                        <span>Update</span>
                                                    </b-button>
                                                </div>
                                            </b-col>
                                        </b-row>
                                    </b-container>
                                    <b-row>
                                        <b-col sm="9" class="mt-3">
                                        </b-col>
                                        <b-col sm="3" class="mt-3">
                                            <div style="clear: both; float: right;"><span v-html="processingMessage" />
                                            </div>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-card-text>
                        </b-tab>
                        <b-tab class="mb-4">
                            <template v-slot:title>
                                <h6 class="mb-2 mt-3"
                                    style="font-weight: 600; font-size:17px; font-family:roboto; color:#1D1D1D;">
                                    LEARNING</h6>
                            </template>
                            <b-container>
                                <b-card-text>
                                    <b-col>
                                        <b-row>
                                            <b-col sm="">
                                                <h5 style="font-weight:600; font-family:Roboto; color:#202020;">Learning
                                                </h5>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                            </b-container>
                            <b-card-text>
                                <b-col>
                                    <b-row>
                                        <b-col>
                                            <b-container>
                                                <b-tabs justified pills card nav-wrapper-class="w-40"
                                                    style="background-color: white;">
                                                    <b-tab active>
                                                        <template v-slot:title>
                                                            <h6 class="mb-0"
                                                                style="font-weight: normal; color:#1D1D1D;">Key Lessons
                                                            </h6>
                                                        </template>
                                                        <div class="row">
                                                            <b-col sm="12" class="h-25" style="">
                                                                <div v-bind:style="keylessonsShow"
                                                                    v-html="model.lessons"></div>
                                                                <vue-editor v-bind:style="keylessonsEdit" id="lessons"
                                                                    name="lessons" placeholder="" rows="2" max-rows="8"
                                                                    v-bind:disabled="savingInfo"
                                                                    v-model="model.lessons"></vue-editor>
                                                            </b-col>
                                                        </div>
                                                        <div class="row">
                                                            <b-col sm="10">
                                                            </b-col>
                                                            <b-col sm="2" class="mt-2"
                                                                style="text-align:center; background-color:#96C65A;">
                                                                <div style="float: left;">
                                                                    <b-button @click="editKeylessons = false"
                                                                        v-bind:style="keylessonsEdit" type="submit"
                                                                        v-bind:disabled="savingInfo" class="" size="md"
                                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                                        <span v-if="savingInfo"><i
                                                                                class="fa fa-spinner fa-spin"></i>
                                                                            Loading
                                                                            ...</span>
                                                                        <span v-else>{{ saveText }}</span>
                                                                    </b-button>
                                                                    <b-button size="md" @click="editKeylessons = true"
                                                                        v-bind:style="keylessonsShow"
                                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                                        <span>Update</span>
                                                                    </b-button>
                                                                </div>
                                                            </b-col>
                                                        </div>
                                                        <b-row>
                                                            <b-col sm="9" class="mt-3">
                                                            </b-col>
                                                            <b-col sm="3" class="mt-3">
                                                                <div style="clear: both; float: right;"><span
                                                                        v-html="processingMessage" />
                                                                </div>
                                                            </b-col>
                                                        </b-row>
                                                    </b-tab>
                                                    <b-tab>
                                                        <template v-slot:title>
                                                            <h6 class="mb-0"
                                                                style="font-weight: normal; color:#1D1D1D;">Best
                                                                Practices</h6>
                                                        </template>
                                                        <div class="row">
                                                            <b-col sm="12" class="h-25" style="">
                                                                <div v-bind:style="bestpracticesShow"
                                                                    v-html="model.practices"></div>
                                                                <vue-editor v-bind:style="bestpracticesEdit"
                                                                    id="practices" name="practices" placeholder=""
                                                                    rows="2" max-rows="8" v-bind:disabled="savingInfo"
                                                                    v-model="model.practices" style=""></vue-editor>
                                                            </b-col>
                                                        </div>
                                                        <div class="row">
                                                            <b-col sm="10">
                                                            </b-col>
                                                            <b-col sm="2" class="mt-2"
                                                                style="text-align:center; background-color:#96C65A;">
                                                                <div style="float: left;">
                                                                    <b-button @click="editBestpractices = false"
                                                                        v-bind:style="bestpracticesEdit" type="submit"
                                                                        v-bind:disabled="savingInfo" class="" size="md"
                                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                                        <span v-if="savingInfo"><i
                                                                                class="fa fa-spinner fa-spin"></i>
                                                                            Loading
                                                                            ...</span>
                                                                        <span v-else>{{ saveText }}</span>
                                                                    </b-button>
                                                                    <b-button size="md"
                                                                        @click="editBestpractices = true"
                                                                        v-bind:style="bestpracticesShow"
                                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                                        <span>Update</span>
                                                                    </b-button>
                                                                </div>
                                                                <br>
                                                                <div style="clear: both; float: right;"><span
                                                                        v-html="processingMessage" />
                                                                </div>
                                                            </b-col>
                                                        </div>
                                                        <b-row>
                                                            <b-col sm="9" class="mt-3">
                                                            </b-col>
                                                            <b-col sm="3" class="mt-3">
                                                                <div style="clear: both; float: right;"><span
                                                                        v-html="processingMessage" />
                                                                </div>
                                                            </b-col>
                                                        </b-row>
                                                    </b-tab>
                                                    <b-tab>
                                                        <template v-slot:title>
                                                            <h6 class="mb-0"
                                                                style="font-weight: normal; color:#1D1D1D;">
                                                                Opportunities</h6>
                                                        </template>
                                                        <b-row class="my-1">
                                                            <b-col sm="12" class="h-25" style="">
                                                                <div v-bind:style="opportunitiesShow"
                                                                    v-html="model.opportunities"></div>
                                                                <vue-editor v-bind:style="opportunitiesEdit"
                                                                    id="opportunities" name="opportunities"
                                                                    placeholder="" rows="2" max-rows="8"
                                                                    v-bind:disabled="savingInfo"
                                                                    v-model="model.opportunities"></vue-editor>
                                                            </b-col>
                                                        </b-row>
                                                        <div class="row">
                                                            <b-col sm="10">
                                                            </b-col>
                                                            <b-col sm="2" class="mt-2"
                                                                style="text-align:center; background-color:#96C65A;">
                                                                <div style="float: left;">
                                                                    <b-button @click="editOpportunities = false"
                                                                        v-bind:style="opportunitiesEdit" type="submit"
                                                                        v-bind:disabled="savingInfo" class="" size="md"
                                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                                        <span v-if="savingInfo"><i
                                                                                class="fa fa-spinner fa-spin"></i>
                                                                            Loading
                                                                            ...</span>
                                                                        <span v-else>{{ saveText }}</span>
                                                                    </b-button>
                                                                    <b-button size="md"
                                                                        @click="editOpportunities = true"
                                                                        v-bind:style="opportunitiesShow"
                                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                                        <span>Update</span>
                                                                    </b-button>
                                                                </div>
                                                            </b-col>
                                                        </div>
                                                        <b-row>
                                                            <b-col sm="9" class="mt-3">
                                                            </b-col>
                                                            <b-col sm="3" class="mt-3">
                                                                <div style="clear: both; float: right;"><span
                                                                        v-html="processingMessage" />
                                                                </div>
                                                            </b-col>
                                                        </b-row>
                                                    </b-tab>
                                                    <b-tab>
                                                        <template v-slot:title>
                                                            <h6 class="mb-0"
                                                                style="font-weight: normal; color:#1D1D1D;">Challenges
                                                            </h6>
                                                        </template>
                                                        <b-row class="my-1">
                                                            <b-col sm="12" class="h-25" style="">
                                                                <div v-bind:style="challengesShow"
                                                                    v-html="model.challenges"></div>
                                                                <vue-editor v-bind:style="challengesEdit"
                                                                    id="challenges" name="challenges" placeholder=""
                                                                    rows="2" max-rows="8" v-bind:disabled="savingInfo"
                                                                    v-model="model.challenges"></vue-editor>
                                                            </b-col>
                                                        </b-row>
                                                        <div class="row">
                                                            <b-col sm="10">
                                                            </b-col>
                                                            <b-col sm="2" class="mt-2"
                                                                style="text-align:center; background-color:#96C65A;">
                                                                <div style="float: left;">
                                                                    <b-button @click="editChallenges = false"
                                                                        v-bind:style="challengesEdit" type="submit"
                                                                        v-bind:disabled="savingInfo" class="" size="md"
                                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                                        <span v-if="savingInfo"><i
                                                                                class="fa fa-spinner fa-spin"></i>
                                                                            Loading
                                                                            ...</span>
                                                                        <span v-else>{{ saveText }}</span>
                                                                    </b-button>
                                                                    <b-button size="md" @click="editChallenges = true"
                                                                        v-bind:style="challengesShow"
                                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                                        <span>Update</span>
                                                                    </b-button>
                                                                </div>
                                                            </b-col>
                                                        </div>
                                                        <b-row>
                                                            <b-col sm="9" class="mt-3">
                                                            </b-col>
                                                            <b-col sm="3" class="mt-3">
                                                                <div style="clear: both; float: right;"><span
                                                                        v-html="processingMessage" />
                                                                </div>
                                                            </b-col>
                                                        </b-row>
                                                    </b-tab>
                                                    <b-tab>
                                                        <template v-slot:title>
                                                            <h6 class="mb-0"
                                                                style="font-weight: normal; color:#1D1D1D;">Gaps</h6>
                                                        </template>
                                                        <b-row class="my-1">
                                                            <b-col sm="12" class="h-25" style="">
                                                                <div v-bind:style="gapsShow" v-html="model.gaps"></div>
                                                                <vue-editor v-bind:style="gapsEdit" id="gaps"
                                                                    name="gaps" placeholder="" rows="2" max-rows="8"
                                                                    v-bind:disabled="savingInfo"
                                                                    v-model="model.gaps"></vue-editor>
                                                            </b-col>
                                                        </b-row>
                                                        <div class="row">
                                                            <b-col sm="10">
                                                            </b-col>
                                                            <b-col sm="2" class="mt-2"
                                                                style="text-align:center; background-color:#96C65A;">
                                                                <div style="float: left;">
                                                                    <b-button @click="editGaps = false"
                                                                        v-bind:style="gapsEdit" type="submit"
                                                                        v-bind:disabled="savingInfo" class="" size="md"
                                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                                        <span v-if="savingInfo"><i
                                                                                class="fa fa-spinner fa-spin"></i>
                                                                            Loading
                                                                            ...</span>
                                                                        <span v-else>{{ saveText }}</span>
                                                                    </b-button>
                                                                    <b-button size="md" @click="editGaps = true"
                                                                        v-bind:style="gapsShow"
                                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                                        <span>Update</span>
                                                                    </b-button>
                                                                </div>
                                                            </b-col>
                                                        </div>
                                                        <b-row>
                                                            <b-col sm="9" class="mt-3">
                                                            </b-col>
                                                            <b-col sm="3" class="mt-3">
                                                                <div style="clear: both; float: right;"><span
                                                                        v-html="processingMessage" />
                                                                </div>
                                                            </b-col>
                                                        </b-row>
                                                    </b-tab>
                                                    <b-tab>
                                                        <template v-slot:title>
                                                            <h6 class="mb-0"
                                                                style="font-weight: normal; color:#1D1D1D;">Risks</h6>
                                                        </template>
                                                        <b-row class="my-1">
                                                            <b-col sm="12" class="h-25" style="">
                                                                <div v-bind:style="risksShow" v-html="model.risks">
                                                                </div>
                                                                <vue-editor v-bind:style="risksEdit" id="risks"
                                                                    name="risks" placeholder="" rows="2" max-rows="8"
                                                                    v-bind:disabled="savingInfo"
                                                                    v-model="model.risks"></vue-editor>
                                                            </b-col>
                                                        </b-row>
                                                        <div class="row">
                                                            <b-col sm="10">
                                                            </b-col>
                                                            <b-col sm="2" class="mt-2"
                                                                style="text-align:center; background-color:#96C65A;">
                                                                <div style="float: left;">
                                                                    <b-button @click="editRisks = false"
                                                                        v-bind:style="risksEdit" type="submit"
                                                                        v-bind:disabled="savingInfo" class="" size="md"
                                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                                        <span v-if="savingInfo"><i
                                                                                class="fa fa-spinner fa-spin"></i>
                                                                            Loading
                                                                            ...</span>
                                                                        <span v-else>{{ saveText }}</span>
                                                                    </b-button>
                                                                    <b-button size="md" @click="editRisks = true"
                                                                        v-bind:style="risksShow"
                                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                                        <span>Update</span>
                                                                    </b-button>
                                                                </div>
                                                            </b-col>
                                                        </div>
                                                        <b-row>
                                                            <b-col sm="9" class="mt-3">
                                                            </b-col>
                                                            <b-col sm="3" class="mt-3">
                                                                <div style="clear: both; float: right;"><span
                                                                        v-html="processingMessage" />
                                                                </div>
                                                            </b-col>
                                                        </b-row>
                                                    </b-tab>
                                                </b-tabs>
                                            </b-container>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-card-text>
                        </b-tab>
                        <b-tab class="mb-4">
                            <template v-slot:title>
                                <h6 class="mb-2 mt-3"
                                    style="font-weight: 600; font-size:17px; font-family:roboto; color:#1D1D1D;">PARTNERS
                                </h6>
                            </template>
                            <b-container>
                                <b-card-text>
                                    <b-col>
                                        <b-row>
                                            <b-col>
                                                <h5 style="font-weight: 600; font-family:Roboto; color:#202020;">
                                                    Partners</h5>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                                <b-card-text>
                                    <b-col>
                                        <b-row>
                                            <b-col class="h-25">
                                                <div v-bind:style="partnersShow" v-html="model.partners"></div>
                                                <vue-editor v-bind:style="partnersEdit" id="partners" name="partners"
                                                    placeholder="" rows="2" max-rows="8" v-bind:disabled="savingInfo"
                                                    v-model="model.partners" />
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                                <b-card-text>
                                    <b-col>
                                        <b-row>
                                            <b-col sm="10">
                                            </b-col>
                                            <b-col sm="2" class="mt-2"
                                                style="text-align:center; background-color:#96C65A;">
                                                <div style="float: left;">
                                                    <b-button @click="editPartners = false" v-bind:style="partnersEdit"
                                                        type="submit" v-bind:disabled="savingInfo" class="" size="md"
                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                        <span v-if="savingInfo"><i class="fa fa-spinner fa-spin"></i>
                                                            Loading ...</span>
                                                        <span v-else>{{ saveText }}</span>
                                                    </b-button>
                                                    <b-button size="md" @click="editPartners = true"
                                                        v-bind:style="partnersShow"
                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                        <span>Update</span>
                                                    </b-button>
                                                </div>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col sm="9" class="mt-3">
                                            </b-col>
                                            <b-col sm="3" class="mt-3">
                                                <div style="clear: both; float: right;"><span
                                                        v-html="processingMessage" /></div>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                            </b-container>
                        </b-tab>
                        <b-tab class="mb-4">
                            <template v-slot:title>
                                <h6 class="mb-2 mt-3"
                                    style="font-weight: 600; font-size:17px; font-family:roboto; color:#1D1D1D;">
                                    CONTRIBUTION TO HIGHER GOALS</h6>
                            </template>
                            <b-container>
                                <b-card-text>
                                    <b-col>
                                        <b-row>
                                            <b-col>
                                                <h5 class="mheader"
                                                    style="font-weight:600; font-family:Roboto; color:#202020;">
                                                    Contributions to
                                                    Higher
                                                    Goals (SDGs)</h5>
                                                <ul>
                                                    <li v-if="modelData['sdg_outcome'].length == 0"><span
                                                            style="font-family:roboto; font-size:18px;">NO SDGs</span>
                                                    </li>
                                                    <li v-for="item in modelData['sdg_outcome']" :key="item.id"
                                                        style="font-family:roboto; font-size:18px;">
                                                        {{ item.sdg }}
                                                    </li>
                                                </ul>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                                <b-card-text>
                                    <b-col>
                                        <b-row>
                                            <b-col>
                                                <h5 style="font-weight: 600; font-family:Roboto; color:#202020;">MEAs
                                                </h5>
                                            </b-col>
                                            <!--<b-col sm="10"> 
                                <b-form-select v-model="model.mea_id" :options="meaOptions"
                                               v-bind:disabled="savingInfo">
                                    <template v-slot:first>
                                        <option value="">-- none --</option>
                                    </template>
                                </b-form-select>
                            </b-col>-->
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                                <b-card-text>
                                    <b-col>
                                        <b-row>
                                            <b-col sm="12">
                                                <ul>
                                                    <li v-for="item in model['meas_ids']" :key="item.id"
                                                        style="font-family:roboto; font-size:18px;">
                                                        {{ item.text }}
                                                    </li>
                                                </ul>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col sm="12" v-bind:style="measEdit">
                                                <multiselect class="mymultiselect" v-bind:disabled="savingInfo"
                                                    v-model="model.meas_ids" id="meas_ids" :options="measOptions"
                                                    :multiple="true" :searchable="true" :loading="isLoadingMeas"
                                                    :internal-search="false" :clear-on-select="false"
                                                    :close-on-select="false" :options-limit="300" :limit="7"
                                                    :limit-text="limitTextMeas" :max-height="600"
                                                    :show-no-results="false"
                                                    :class="(model.meas_ids.length == 0 ? 'emptySelect' : '')"
                                                    :hide-selected="true" @search-change="asyncFindMeas"
                                                    placeholder="Type to search Meas" track-by="value" label="text">
                                                    <span slot="noResult">No Meas found. Your search query is empty or
                                                        returned no
                                                        results.</span>
                                                </multiselect>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                                <b-card-text>
                                    <b-col>
                                        <b-row>
                                            <b-col sm="10">
                                            </b-col>
                                            <b-col sm="2" class="mt-2"
                                                style="text-align:center; background-color:#96C65A;">
                                                <div style="float: center;">
                                                    <b-button @click="editMeas = false" v-bind:style="measEdit"
                                                        type="submit" v-bind:disabled="savingInfo" class="" size="md"
                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                        <span v-if="savingInfo"><i class="fa fa-spinner fa-spin"></i>
                                                            Loading ...</span>
                                                        <span v-else>{{ saveText }}</span>
                                                    </b-button>
                                                    <b-button size="md" @click="editMeas = true" v-bind:style="measShow"
                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                        <span>Update</span>
                                                    </b-button>
                                                </div>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col sm="9" class="mt-3">
                                            </b-col>
                                            <b-col sm="3" class="mt-3">
                                                <div style="clear: both;"><span v-html="processingMessage" /></div>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                            </b-container>
                        </b-tab>
                        <b-tab class="mb-4">
                            <template v-slot:title>
                                <h6 class="mb-2 mt-3"
                                    style="font-weight: 600; font-size:17px; font-family:roboto; color:#1D1D1D;">
                                    RELEVANCE TO NATIONAL & REGIONAL PRIORITIES</h6>
                            </template>
                            <b-container>
                                <b-card-text>
                                    <b-row>
                                        <b-col sm="4">
                                            <h5 style="font-weight: 600; font-family:Roboto; color:#202020;">Priority Alignment</h5>
                                        </b-col>
                                        <b-col sm="8">
                                            <b-form-select size="" id="national_id" name="national_id"
                                                :options="nationalOptions" v-model="model.national_id"
                                                v-bind:disabled="savingInfo">
                                                <template v-slot:first>
                                                    <option value="">-- none --</option>
                                                </template>
                                            </b-form-select>
                                        </b-col>
                                    </b-row>
                                </b-card-text>
                                <b-card-text>
                                    <b-col>
                                        <b-row>
                                            <b-col sm="12">
                                                <h5 style="font-weight: 600; font-family:Roboto; color:#202020;"></h5>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                                <b-card-text>
                                    <b-col>
                                        <b-row>
                                            <b-col class="h-25">
                                                <div v-bind:style="nationalShow" v-html="model.national"></div>
                                                <vue-editor v-bind:style="nationalEdit" id="national" name="national"
                                                    placeholder="" rows="2" max-rows="8" v-bind:disabled="savingInfo"
                                                    v-model="model.national" />
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                                <b-card-text>
                                    <b-col>
                                        <b-row>
                                            <b-col sm="10">
                                            </b-col>
                                            <b-col sm="2" class="mt-2"
                                                style="text-align:center; background-color:#96C65A;">
                                                <div style="float: left;">
                                                    <b-button @click="editNational = false" v-bind:style="nationalEdit"
                                                        type="submit" v-bind:disabled="savingInfo" class="" size="md"
                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                        <span v-if="savingInfo"><i class="fa fa-spinner fa-spin"></i>
                                                            Loading ...</span>
                                                        <span v-else>{{ saveText }}</span>
                                                    </b-button>
                                                    <b-button size="md" @click="editNational = true"
                                                        v-bind:style="nationalShow"
                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                        <span>Update</span>
                                                    </b-button>
                                                </div>
                                                <br>
                                                <div style="clear: both; float: left;"><span
                                                        v-html="processingMessage" /></div>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col sm="9" class="mt-3">
                                            </b-col>
                                            <b-col sm="3" class="mt-3">
                                                <div style="clear: both; float: right;"><span
                                                        v-html="processingMessage" /></div>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                            </b-container>
                        </b-tab>
                        <b-tab class="mb-4">
                            <template v-slot:title>
                                <h6 class="mb-2 mt-3"
                                    style="font-weight: 600; font-size:17px; font-family:roboto; color:#1D1D1D;">NEXT
                                    STEPS</h6>
                            </template>
                            <b-container>
                                <b-card-text>
                                    <b-col>
                                        <b-row>
                                            <b-col sm="">
                                                <h5 style="font-weight: 600; font-family:Roboto; color:#202020;">Next
                                                    Steps</h5>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                                <b-card-text>
                                    <b-col>
                                        <b-row>
                                            <b-col class="h-25">
                                                <div v-bind:style="nextstepsShow" v-html="model.next_steps"></div>
                                                <vue-editor v-bind:style="nextstepsEdit" id="next_steps"
                                                    name="next_steps" placeholder="" :maxlength="max" rows="2"
                                                    max-rows="8" v-bind:disabled="savingInfo"
                                                    v-model="model.next_steps"></vue-editor>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                                <b-card-text>
                                    <b-col>
                                        <b-row>
                                            <b-col sm="10">
                                            </b-col>
                                            <b-col sm="2" class="mt-2"
                                                style="text-align:center; background-color:#96C65A;">
                                                <b-button @click="editNextsteps = false" v-bind:style="nextstepsEdit"
                                                    type="submit" v-bind:disabled="savingInfo" class="" size="md"
                                                    style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                    <span v-if="savingInfo"><i class="fa fa-spinner fa-spin"></i>
                                                        Loading ...</span>
                                                    <span v-else>{{ saveText }}</span>
                                                </b-button>
                                                <b-button size="md" @click="editNextsteps = true"
                                                    v-bind:style="nextstepsShow"
                                                    style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                    <span>Update</span>
                                                </b-button>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col sm="9" class="mt-3">
                                            </b-col>
                                            <b-col sm="3" class="mt-3">
                                                <div style="clear: both; float: right;"><span
                                                        v-html="processingMessage" /></div>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                            </b-container>
                        </b-tab>
                        <b-tab>
                            <template v-slot:title>
                                <h6 class="mt-3"
                                    style="font-weight: 600; font-size:17px; font-family:roboto; color:#9BC455;">CONFIRM
                                    YOUR SUBMISSION</h6>
                            </template>
                            <b-container>
                                <b-card-text style="" class="mt-4">
                                    <b-col sm="12">
                                        <b-row>
                                            <b-col sm="12">
                                                <ol style="font-size:17px;">
                                                    <li>Please confirm that you have saved all of your information.</li>
                                                    <li>Confirm that you have filled all the fields information
                                                        correctly.</li>
                                                </ol>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col sm="9">
                                            </b-col>
                                            <b-col sm="3" style="text-align:center;">
                                                <label for="agree">
                                                    <!--<input id="agree" type="checkbox" value="1" v-model="model.submitted"/> I Confirm-->
                                                    <b-form-checkbox id="agree" v-model="model.submitted"
                                                        name="checkbox-1" value="2" unchecked-value="1">
                                                        I Confirm
                                                    </b-form-checkbox>
                                                </label>

                                            </b-col>
                                        </b-row>
                                        <b-row class="mt-3">
                                            <b-col sm="10">
                                            </b-col>
                                            <b-col sm="2" style="text-align:center; background-color:#96C65A;">
                                                <b-button v-bind:disabled="model.submitted == 1" name="submittedButton"
                                                    type="submit" size="md"
                                                    style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                    <span v-if="savingInfo"><i class="fa fa-spinner fa-spin"></i>
                                                        Loading ...</span>
                                                    <span v-else>Submit</span>
                                                </b-button>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                            </b-container>
                        </b-tab>
                    </div>
                </form>
            </b-tabs>
            <b-row>
                <b-col sm="">
                    <p> </p>
                </b-col>
            </b-row>
        </div>
        <b-modal id="modalSubmitted" hide-footer>
            <template v-slot:modal-title>Confirmation</template>
            <div>
                <h4>Data submitted successfully</h4>
            </div>
            <b-button size="sm" variant="primary" @click="$bvModal.hide('modalSubmitted')">Close</b-button>
        </b-modal>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
    components: {
        Multiselect
    },
    name: 'MemberReporting',
    data() {
        return {
            apiUrl: process.env.VUE_APP_API_PATH,
            max: 400,
            tabIndex: 1,
            submitted: 0,
            boxTwo: '',
            id: '',
            risksOptions: [],
            successOptions: [],
            challengesOptions: [],
            gapsOptions: [],
            opportunitiesOptions: [],
            meaOptions: [],
            measState: null,
            measOptions: [],
            isLoadingMeas: false,
            nationalOptions: [],
            powOptions: [],
            editImpact: false,
            editOutcome: false,
            editKeylessons: false,
            editGaps: false,
            editChallenges: false,
            editOpportunities: false,
            editNextsteps: false,
            editMeas: false,
            editRisks: false,
            editNational: false,
            editBestpractices: false,
            editPartners: false,
            editResources: false,
            processingMessage: '',
            savingInfo: false,
            userCountry: 'Loading ...',
            modelData: [],
            tmpData: {}, /* HERE ADDED */
            model: {
                id: '',
                period_id: '',
                country_id: '',
                category_id: '',
                success_id: '',
                success: '',
                challenge_id: '',
                challenges: '',
                gap_id: '',
                gaps: '',
                opportunity_id: '',
                opportunities: '',
                risk_id: '',
                risks: '',
                output: '',
                impact: '',
                mea_id: '',
                meas_ids: [],
                meas: '',
                national_id: '',
                national: '',
                resources: '',
                partners: '',
                lessons: '',
                practices: '',
                next_steps: '',
                submitted: '0',
            }
        }
    },
    computed: {
        hideTabs() {
            return (this.model.period_id == '');
        },
        saveText() {
            if (this.model.id) {
                return "Save";
            }

            return "Save";
        },
        showMsgBoxTwo() {
            this.$bvModal.show('modalSubmitted');
        },
        resultEdit() {
            if (this.editResult) {
                return "display: block;";
            } else {
                return "display: none;";
            }
        },
        resultShow() {
            if (this.editResult) {
                return "display: none;";
            } else {
                return "display: block;";
            }
        },
        nationalEdit() {
            if (this.editNational) {
                return "display: block;";
            } else {
                return "display: none;";
            }
        },
        nationalShow() {
            if (this.editNational) {
                return "display: none;";
            } else {
                return "display: block;";
            }
        },
        measEdit() {
            if (this.editMeas) {
                return "display: block;";
            } else {
                return "display: none;";
            }
        },
        measShow() {
            if (this.editMeas) {
                return "display: none;";
            } else {
                return "display: block;";
            }
        },
        nextstepsEdit() {
            if (this.editNextsteps) {
                return "display: block;";
            } else {
                return "display: none;";
            }
        },
        nextstepsShow() {
            if (this.editNextsteps) {
                return "display: none;";
            } else {
                return "display: block;";
            }
        },
        risksEdit() {
            if (this.editRisks) {
                return "display: block;";
            } else {
                return "display: none;";
            }
        },
        risksShow() {
            if (this.editRisks) {
                return "display: none;";
            } else {
                return "display: block;";
            }
        },
        keylessonsEdit() {
            if (this.editKeylessons) {
                return "display: block;";
            } else {
                return "display: none;";
            }
        },
        keylessonsShow() {
            if (this.editKeylessons) {
                return "display: none;";
            } else {
                return "display: block;";
            }
        },
        opportunitiesEdit() {
            if (this.editOpportunities) {
                return "display: block;";
            } else {
                return "display: none;";
            }
        },
        opportunitiesShow() {
            if (this.editOpportunities) {
                return "display: none;";
            } else {
                return "display: block;";
            }
        },
        challengesEdit() {
            if (this.editChallenges) {
                return "display: block;";
            } else {
                return "display: none;";
            }
        },
        challengesShow() {
            if (this.editChallenges) {
                return "display: none;";
            } else {
                return "display: block;";
            }
        },
        gapsEdit() {
            if (this.editGaps) {
                return "display: block;";
            } else {
                return "display: none;";
            }
        },
        gapsShow() {
            if (this.editGaps) {
                return "display: none;";
            } else {
                return "display: block;";
            }
        },
        bestpracticesEdit() {
            if (this.editBestpractices) {
                return "display: block;";
            } else {
                return "display: none;";
            }
        },
        bestpracticesShow() {
            if (this.editBestpractices) {
                return "display: none;";
            } else {
                return "display: block;";
            }
        },
        partnersEdit() {
            if (this.editPartners) {
                return "display: block;";
            } else {
                return "display: none;";
            }
        },
        partnersShow() {
            if (this.editPartners) {
                return "display: none;";
            } else {
                return "display: block;";
            }
        },
        impactEdit() {
            if (this.editImpact) {
                return "display: block;";
            } else {
                return "display: none;";
            }
        },
        impactShow() {
            if (this.editImpact) {
                return "display: none;";
            } else {
                return "display: block;";
            }
        },
        outcomeEdit() {
            if (this.editOutcome) {
                return "display: block;";
            } else {
                return "display: none;";
            }
        },
        outcomeShow() {
            if (this.editOutcome) {
                return "display: none;";
            } else {
                return "display: block;";
            }
        },
        resourcesEdit() {
            if (this.editResources) {
                return "display: block;";
            } else {
                return "display: none;";
            }
        },
        resourcesShow() {
            if (this.editResources) {
                return "display: none;";
            } else {
                return "display: block;";
            }
        },
    },
    created() {
        this.id = this.$route.params.id;
    },
    mounted() {
        this.fetchData();
        console.log(this.modelData['reporting_country']);

    },
    methods: {
        limitTextMeas(count) {
            return `and ${count} other meas`
        },
        asyncFindMeas(query) {
            this.isLoadingMeas = true;
            let url = this.apiUrl;
            fetch(url + '/getmeasoptions?search=' + query)
                .then(res => res.json())
                .then(res => {
                    this.measOptions = res;
                    this.isLoadingMeas = false;
                })
        },
        clearAllMeas() {
            this.model.meas_ids = []
        },

        getLoggedInUserId() {
            let loggedInUserId = document.getElementById('loggedInUserId');
            return loggedInUserId == null ? 'guest' : loggedInUserId.value;
        },
        getLoggedInUserEmail() {
            let loggedInUserEmail = document.getElementById('loggedInUserEmail');
            return loggedInUserEmail == null ? 'shadrack.kirui@un.org' : loggedInUserEmail.value;
        },
        getLoggedInUserName() {
            let loggedInUserName = document.getElementById('loggedInUserName');
            return loggedInUserName == null ? '' : loggedInUserName.value;
        },

        loadReport() {
            let url = this.apiUrl;
            fetch(url + '/getreport?type=0&outcome_id=' + this.id + "&category_id=" + this.model.category_id + "&country_id=" + this.model.country_id + "&period_id=" + this.model.period_id + "&loggedInUserId=" + this.getLoggedInUserId() + "&loggedInUserName=" + this.getLoggedInUserName() + "&loggedInUserEmail=" + this.getLoggedInUserEmail())
                .then(res => res.json())
                .then(res => {
                    console.log("Data from loadReport:", res['data']); 
                    for (let key in res['data']['model']) {
                        if (key == 'period_id') continue;
                        this.model[key] = res['data']['model'][key];
                    }
                    /* for (let key in res['data']['model']) {
                        if (key == 'country_id') continue;
                        this.model[key] = res['data']['model'][key];
                    }*/
                })
                .catch(error => {
                    console.log(error)
                });
        },
        fetchData() {
            let url = this.apiUrl;
            fetch(url + '/getoutcome?id=' + this.id)
                .then(res => res.json())
                .then(res => {
                    this.modelData = res['data'];
                    console.log("Data from fetchData:", res['data']);
                    console.log("Posted Data:", this.modelData['postData']);
                    this.successOptions = this.modelData['successOptions'];
                    this.opportunitiesOptions = this.modelData['opportunitiesOptions'];
                    this.risksOptions = this.modelData['risksOptions'];
                    this.challengesOptions = this.modelData['challengesOptions'];
                    this.gapsOptions = this.modelData['gapsOptions'];
                    this.meaOptions = this.modelData['meaOptions'];
                    this.nationalOptions = this.modelData['nationalOptions'];
                    this.userCountry = res['countryName'];

                    // Optional: If you want to display the country somewhere in the UI, ensure you have a corresponding element
                    if (document.getElementById('userCountry')) {
                        document.getElementById('userCountry').textContent = this.userCountry;
                    }
                });
        },
        saveEditReports: function () {
            let buttonName = document.activeElement.name;
            //if (confirm("Are you sure you want to submit?")) {
            this.savingInfo = true;
            this.processingMessage = '';
            var thisRef = this;

            if (!this.$refs.form.checkValidity()) {
                this.savingInfo = false;
                return
            }

            this.processingMessage = "<span style='color: orange;'>Saving report ...</span>";
            let url = this.apiUrl + '/addreportmemberstate/' + this.id + "?period_id=" + this.model.period_id + "&loggedInUserId=" + this.getLoggedInUserId() + "&loggedInUserName=" + this.getLoggedInUserName() + "&loggedInUserEmail=" + this.getLoggedInUserEmail();

            fetch(url, {
                method: 'post',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(this.model)
            })
                .then((res) => {
                    if (!res.ok) {
                        throw new Error("HTTP status " + res.status);
                    }
                    return res.json();
                })
                .then(res => {
                    this.savingInfo = false;
                    if (res.success) {
                        if (buttonName == 'submittedButton') {
                            this.showMsgBoxTwo();
                        } else {
                            this.processingMessage = "<span style='color: green;'>" + (this.id > 0 ? 'Saved' : 'saved') + " successfully.</span>";
                        }
                    } else {
                        if (buttonName == 'submittedButton') {
                            this.showMsgBoxTwo();
                        } else {
                            this.processingMessage = "<span style='color: red;'>Error occurred: " + res.message + "</span>";
                        }
                    }
                    setTimeout(function () {
                        thisRef.processingMessage = "";
                    }, 2000);
                }).catch(error => {
                    this.savingInfo = false;
                    this.processingMessage = "<span style='color: red;'>Error occurred: " + error + "</span>";
                    setTimeout(function () {
                        thisRef.processingMessage = "";
                    }, 2000);
                });
            //}
        }
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect__tag {
    background-color: rgb(0, 173, 238);
}

.emptySelect .multiselect__content li:first-child {
    display: block !important;
}

.emptySelect .multiselect__content li:last-child {
    display: none !important;
}

.nav-item {
    font-size: small !important;
    border-bottom: none !important;
    background-color: rgb(235 235 235) !important;
    border-bottom: 2px solid white;
}

.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
    color: #fff !important;
    background-color: #D3D3D3 !important;
    border-bottom: gray !important;
}

.quillWrapper {
    max-width: 560px;
}

.row-container {
    height: 46px !important;
    width: 306px !important;
}

.nav-pills .nav-link {
    border-radius: unset !important;
}

.card-header {
    padding: 0rem 0rem !important;
    margin-bottom: 0;
    background-color: rgba(0, 0, 0, 0.03);
    border-bottom: none !important;
}
</style>